<template>
  <v-card>
    <v-tabs
      v-model="currentTab"
      bg-color="white"
      color="primary"
      center-active
      grow
      show-arrows
      class="elevation-2"
    >
      <v-tab
        v-for="(tab, index) in tabs"
        :key="index"
        :value="index"
        :disabled="loading || tab.disabled?.()"
      >
        <v-icon
          color="primary"
          start
          :icon="tab.icon"
        />
        <span class="text-grey-darken-1">{{ tab.title }}</span>
      </v-tab>
    </v-tabs>
    <v-window v-model="currentTab">
      <v-window-item
        v-for="(tab, index) in tabs"
        :key="index"
        :value="index"
        :eager="!!tab.eager"
      >
        <v-card-text>
          <keep-alive>
            <component
              :is="tab.component"
              v-bind="tab.props"
              @submit="($payload: unknown) => submit($payload)"
              @close="close"
            />
          </keep-alive>
        </v-card-text>
      </v-window-item>
      <slot name="window-footer" />
    </v-window>
  </v-card>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'
import type { TabProp } from '@/types/vuetify/Tab'

export default defineComponent({
  props: {
    tabs: {
      type: Array as PropType<TabProp[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['submit', 'close', 'tab-change'],
  data() {
    return {
      currentTab: 0,
    }
  },
  watch: {
    currentTab(newValue) {
      this.$emit('tab-change', newValue)
    },
  },
  methods: {
    submit(payload: unknown) {
      this.$emit('submit', payload)
    },
    close() {
      this.$emit('close')
    },
  },
})
</script>
